module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": 'FTP' + _vm.$t('app_addconfig'),
      "size": ""
    },
    model: {
      value: (_vm.isAddFile),
      callback: function($$v) {
        _vm.isAddFile = $$v
      },
      expression: "isAddFile"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fdatas,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_filename'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "size",
      "formatter": _vm.setSize,
      "label": _vm.$t('app_fileSize'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "addTime",
      "label": _vm.$t('app_addtime'),
      "width": "176"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_add'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.addFile(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.data ? _vm.config.data.status === '3' : false),
      expression: "config.data ? config.data.status === '3' : false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filename'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filedesc'),
      "prop": ""
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 9999
      }
    },
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "prop": _vm.ulprop
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.ulType),
      callback: function($$v) {
        _vm.ulType = $$v
      },
      expression: "ulType"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_lcupload')) + "\n        ")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": _vm.form.flag != 'ZT_CARDBLACK',
      "label": "1"
    },
    model: {
      value: (_vm.ulType),
      callback: function($$v) {
        _vm.ulType = $$v
      },
      expression: "ulType"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_addofcloud')) + "\n        ")]), _vm._v(" "), (_vm.ulType == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.fileBeforeUpload,
      "on-success": _vm.fileUploadSuccess,
      "multiple": "",
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('app_limitxml')))])], 1) : _c('span', [_c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isAddFile = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addfile')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.form.fname))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLowerTip),
      expression: "isLowerTip"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('app_udxmllowertip')) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ID'),
      "prop": "flag"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.isTag,
      "clearable": "",
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.form.flag),
      callback: function($$v) {
        _vm.$set(_vm.form, "flag", $$v)
      },
      expression: "form.flag"
    }
  }, _vm._l((_vm.flags), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbf279ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/stfile/edit.vue
// module id = 1119
// module chunks = 0